<template>
    <div class="list-loading">
        <div class="simple-loader" :style="spinnerStyle" aria-hidden="true"></div>
        <div v-if="text" role="alert">{{text}}</div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';

    @Component({
        name: 'LoadingIndicator',
    })
    export default class LoadingIndicator extends Vue
    {
        @Prop({
            type: String,
            default: 'Lädt...',
            required: false,
        }) text: string;

        @Prop({
            type: Object,
            default()
            {
                return {};
            },
        }) spinnerStyle: object;

        mounted()
        {
            if (this.$parent?.$el?.setAttribute)
            {
                this.$parent.$el.setAttribute('aria-live', 'polite');
                this.$parent.$el.setAttribute('aria-busy', 'true');
            }
        }

        unmounted()
        {
            let parentElement = this.$parent?.$el;

            if (!parentElement || !parentElement.setAttribute)
            {
                return;
            }

            parentElement.setAttribute('aria-busy', 'false');

            window.setTimeout(() => {
                parentElement.removeAttribute('aria-busy');
                parentElement.removeAttribute('aria-live');
            }, 1_000);
        }
    }
</script>